// extracted by mini-css-extract-plugin
export default {"card":"KpiCard_card__3Itea","icon":"KpiCard_icon__VLDGi","info":"KpiCard_info__0OXF4","value":"KpiCard_value__Ha4vS","label":"KpiCard_label__BGiCS"};